import Layout from '@/layout';

/** 积分相关（独立于营销 /marketing） */
var integralRouter = {
  path: '/integral',
  component: Layout,
  redirect: '/integral/exchangeConfig',
  name: 'IntegralRoot',
  meta: {
    title: '积分',
    icon: 'clipboard'
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/marketing/integral/index');
    },
    name: 'Integral',
    meta: {
      title: '积分',
      icon: ''
    },
    redirect: 'exchangeConfig',
    children: [{
      path: 'integralconfig',
      component: function component() {
        return import('@/views/marketing/integral/config/index');
      },
      name: 'integralConfig',
      meta: {
        title: '积分配置',
        icon: ''
      }
    }, {
      path: 'integrallog',
      component: function component() {
        return import('@/views/marketing/integral/integralLog/index');
      },
      name: 'integralLog',
      meta: {
        title: '积分日志',
        icon: '',
        cacheDisposable: true
      }
    }, {
      path: 'pointsActivity',
      component: function component() {
        return import('@/views/integral/pointsActivity/index');
      },
      name: 'pointsActivity',
      meta: {
        title: '积分获取配置',
        icon: '',
        cacheDisposable: true
      }
    }, {
      path: 'exchangeConfig',
      component: function component() {
        return import('@/views/integral/exchangeConfig/index');
      },
      name: 'exchangeConfig',
      meta: {
        title: '积分兑换配置',
        icon: '',
        cacheDisposable: true
      }
    }, {
      path: 'userPointsManage',
      component: function component() {
        return import('@/views/integral/userPointsManage/index');
      },
      name: 'userPointsManage',
      meta: {
        title: '用户积分管理',
        icon: '',
        cacheDisposable: true
      }
    }, {
      path: 'systemConfig',
      component: function component() {
        return import('@/views/integral/systemConfig/index');
      },
      name: 'integralSystemConfig',
      meta: {
        title: '积分系统配置',
        icon: ''
      }
    }, {
      path: 'exchangeConfig/save/:mode/:id?',
      component: function component() {
        return import('@/views/integral/exchangeConfig/operate');
      },
      name: 'exchangeConfigOperate',
      hidden: true,
      meta: {
        title: '积分兑换配置',
        noCache: true,
        activeMenu: '/integral/exchangeConfig'
      }
    }, {
      path: 'pointsActivity/save/:mode/:id?',
      component: function component() {
        return import('@/views/integral/pointsActivity/operate');
      },
      name: 'pointsActivityOperate',
      hidden: true,
      meta: {
        title: '积分兑换配置操作',
        noCache: true,
        activeMenu: '/integral/pointsActivity'
      }
    }, {
      path: 'exchangeConfig/goods/:activityId',
      component: function component() {
        return import('@/views/integral/goodsManage/index');
      },
      name: 'exchangeGoodsManage',
      hidden: true,
      meta: {
        title: '积分商品管理',
        noCache: true,
        activeMenu: '/integral/exchangeConfig'
      }
    }, {
      path: 'pointsActivity/goods/:activityId',
      component: function component() {
        return import('@/views/integral/goodsManage/index');
      },
      name: 'pointsGoodsManage',
      hidden: true,
      meta: {
        title: '积分商品管理',
        noCache: true,
        activeMenu: '/integral/pointsActivity'
      }
    }]
  }]
};
export default integralRouter;